import { keyBy, reduce } from "lodash"
import { theme } from "twin.macro"

export const CREATIVE_STATUSES = [
    {
        key: 0,
        label: "Uploading",
        color: theme`colors.orange600`,
        bg: theme`colors.orange200`
    },
    {
        key: 1,
        label: "Uploaded",
        color: theme`colors.teal600`,
        bg: theme`colors.teal200`
    },
    {
        key: 2,
        label: "Failed",
        color: theme`colors.text_error`,
        bg: theme`colors.red200`
    }
]

export const CREATIVE_STATUS_MAP = keyBy(CREATIVE_STATUSES, "key")
export const CREATIVE_STATUS = reduce(
    CREATIVE_STATUSES,
    (acc, crr) => ({ ...acc, [crr.key]: crr.key }),
    {}
)
